export class Figure {
    constructor({label,disabled,namesPath,provable,float}) {
        this.disabled = disabled;           // Does not apply by default (toggle view in ui) eg. not receiving gifts
        this.label = label;                 // e.g. "Basic Salary"
        this.provable = provable;           // whether documentation is expected
        this.isProven = false;            // whether value has been verified
        this.namesPath = namesPath;         // the name used in the lender test figures form
        this.float = float;                 // whether value can be fractional
        this.methodology= []                // for composite - a row for each part of calculation
        this.value = null                   // the final calculated value
        this.alert=null
        this.source = null                  // source of the figure (e.g. "Payslips", "Bank Statements")
    }


    addMethod({
                description,
                claimed,
                amount,
                uploadID=null,
                operator='+',
                warning=null
                      }){
        this.methodology.push({ description,claimed, amount, uploadID, operator, warning });
    }
    setSource(source){
        this.source = source;
    }

    setValue(value, sourceDescription = 'Manual Entry') {
        this.value = value;
        this.source = sourceDescription;
        this.methodology.push({
            description: sourceDescription,
            amount: value,
            operator: '=',
        });
    }
    setAlert(alert){
        this.alert = alert;
    }

    get success() {

        const hasWarning = this.methodology.find(row => row.warning);
        const hasAlert = this.alert;
        return !hasWarning && !hasAlert;
    }
}
